export var createNativeBlobEventConstructor = function createNativeBlobEventConstructor(window) {
  if (window !== null && window.BlobEvent !== undefined) {
    return window.BlobEvent;
  }

  return null;
};